import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getCategoryRequest: ['query', 'categoryLoaded', 'params'],
  getCategorySuccess: ['data'],
  getCategoryError: ['error'],

  setSearchQueryRequest: ['field', 'value'],
  setSearchQuerySuccess: ['data'],
  setSearchQueryError: ['error'],

  getFilteredItemsRequest: [],
  getFilteredItemsSuccess: ['data'],
  getFilteredItemsError: ['error'],

  cleanFilteredItemsRequest: [],
  cleanFilteredItemsSuccess: ['data'],
  cleanFilteredItemsError: ['error'],

  setFormatViewProductsRequest: ['data'],
  setFormatViewProductsSuccess: ['data'],
  setFormatViewProductsError: ['error'],

  setPaginationCategoryRequest: [],
  setPaginationCategorySuccess: ['data'],
  setPaginationCategoryError: ['error'],
});

const INITIAL_STATE = Immutable({
  data: {},
  filters: {},
  products: [],
  totalProducts: 0,
  isLoading: false,
  scrollTo: true,
  searchQuery: {},
  filteredItems: [],
  error: {},
  breadcrumbs: [],
  formatViewProducts: 'grid',
});

const getCategorySuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data });
const getCategoryError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const setSearchQueryRequest = (state = INITIAL_STATE, { field }) =>
  state.merge({ isLoading: true, scrollTo: field !== 'offset', error: {} });
const setSearchQuerySuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data, isLoading: false });
const setSearchQueryError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const getFilteredItemsSuccess = (state = INITIAL_STATE, { data }) => state.merge({ filteredItems: data });
const getFilteredItemsError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const cleanFilteredItemsSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data });
const cleanFilteredItemsError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const setFormatViewProductsRequest = (state = INITIAL_STATE) => state.set('isLoading', true);
const setFormatViewProductsSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data, isLoading: false });
const setFormatViewProductsError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const setPaginationCategoryRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });
const setPaginationCategorySuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data, isLoading: false });
const setPaginationCategoryError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

export default createReducer(INITIAL_STATE, {
  [Types.GET_CATEGORY_SUCCESS]: getCategorySuccess,
  [Types.GET_CATEGORY_ERROR]: getCategoryError,

  [Types.SET_SEARCH_QUERY_REQUEST]: setSearchQueryRequest,
  [Types.SET_SEARCH_QUERY_SUCCESS]: setSearchQuerySuccess,
  [Types.SET_SEARCH_QUERY_ERROR]: setSearchQueryError,

  [Types.GET_FILTERED_ITEMS_SUCCESS]: getFilteredItemsSuccess,
  [Types.GET_FILTERED_ITEMS_ERROR]: getFilteredItemsError,

  [Types.CLEAN_FILTERED_ITEMS_SUCCESS]: cleanFilteredItemsSuccess,
  [Types.CLEAN_FILTERED_ITEMS_ERROR]: cleanFilteredItemsError,

  [Types.SET_FORMAT_VIEW_PRODUCTS_REQUEST]: setFormatViewProductsRequest,
  [Types.SET_FORMAT_VIEW_PRODUCTS_SUCCESS]: setFormatViewProductsSuccess,
  [Types.SET_FORMAT_VIEW_PRODUCTS_ERROR]: setFormatViewProductsError,

  [Types.SET_PAGINATION_CATEGORY_REQUEST]: setPaginationCategoryRequest,
  [Types.SET_PAGINATION_CATEGORY_SUCCESS]: setPaginationCategorySuccess,
  [Types.SET_PAGINATION_CATEGORY_ERROR]: setPaginationCategoryError,
});
